import { createObservableRef } from '@utils/react';

const pm2CurrentAST = createObservableRef(void 0);

export { pm2CurrentAST };
//# sourceMappingURL=hook.pm2-ast.js.map
